import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DSM3NavItem } from '@eredes/dsm3';
import { BehaviorSubject, Subject } from 'rxjs';

import { RequestNavigationService } from 'app/request/request.navigation.service';
import { RequestService } from 'app/request/request.service';

@Component({
  selector: 'app-request-create-form',
  templateUrl: './request-create-form.component.html',
  styleUrls: ['./request-create-form.component.scss'],
  standalone: false,
})
export class RequestCreateFormComponent implements OnInit {
  title: string;
  subTitle: string;
  breadcrumbsItems$: Subject<DSM3NavItem[]>;
  form: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly requestService: RequestService,
    private readonly requestNavigationService: RequestNavigationService
  ) {}

  ngOnInit() {
    const { formType, formAlias } = this.route.snapshot.params;

    this.requestService.getRequestTabs().subscribe((forms) => {
      this.form = this.findForm(forms, formType, formAlias);

      if (this.form) {
        this.title = this.getTitle(this.form.type);
        this.subTitle = this.getSubTitle();
      }

      this.setBreadcrumbs();
    });
  }

  /**
   * extracts subtitle from full request title
   * @returns string containing the subtitle
   */
  getSubTitle(): string {
    const completeTitleList = this.form.title.split('-').map((item) => item.trim());

    if (completeTitleList.length) {
      if (completeTitleList.length > 1) {
        let subTitle = '';
        completeTitleList.forEach((element, index) => {
          if (index === 0) {
            return;
          }

          if (index === completeTitleList.length - 1) {
            subTitle += element;

            return;
          }

          subTitle += element + ' - ';
        });

        return subTitle;
      }

      return completeTitleList[0];
    }

    return '';
  }

  getTitle(type): string {
    if (type === 'PE') {
      return 'Pedido de esclarecimento';
    }

    if (type === 'PO') {
      return 'Pedido de operação';
    }

    return '';
  }

  setBreadcrumbs() {
    const breadcrumbsItems: DSM3NavItem[] = [
      {
        label: 'Pedidos',
        href: '/request/solicitation',
      },
      {
        label: 'Novo Pedido',
        href: '/request/create',
      },
      {
        label: `${this.title} - ${this.subTitle}`,
        active: true,
      },
    ];
    this.breadcrumbsItems$ = new BehaviorSubject<DSM3NavItem[]>(breadcrumbsItems);
  }

  findForm(forms: any[], type: string, alias: string) {
    const children: any[] = [];

    /**
     *
     * @param forms
     */
    function extractValidForms(forms: any[]) {
      if (!forms || forms.length === 0) return;

      forms.forEach((form) => {
        children.push(...extractChildren(form));
        extractValidForms(form.children);
      });
    }

    /**
     *
     * @param form
     */
    function extractChildren(form: any) {
      if (form.children && form.children.length > 0) {
        return form.children.filter((item) => item.type && item.alias);
      }

      return [];
    }

    extractValidForms(forms);

    return children.find((item) => item.type === type && item.alias === alias);
  }

  back() {
    this.requestNavigationService.navigateToPrevious(this.form);
  }
}
